import React, { useEffect } from "react";
import { useLoading } from "../../../hooks/useLoading";
import { useWorklistData } from "./hooks/useWorklistData";
import DataTableV2 from "../../secondary/DataTable/DataTableV2";
import { Pagination } from "../../secondary";

export function WorklistTable({
  facilityNumber,
  loadingKey,
  url,
  asyncThunk,
  selectData,
  columns,
  listKey,
  emptyMessage = "There are no records in this list",
}) {
  const isLoading = useLoading(loadingKey);

  const { patientList, activePage, sortBy, loadInitial, onRowClick, onSort, onPageChange } = useWorklistData({
    url,
    facilityNumber,
    asyncThunk,
    selectData,
  });

  useEffect(() => {
    if (facilityNumber) loadInitial();
  }, [facilityNumber, loadInitial]);

  const list = patientList?.[listKey] ?? [];

  return (
    <>
      <DataTableV2
        columns={columns}
        data={list}
        onRowClick={onRowClick}
        sortBy={sortBy}
        onSort={onSort}
        loading={isLoading}
        emptyMessage={emptyMessage}
      />

      {list.length > 1 && (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={patientList?.metadata?.limit ?? 50}
          totalItemsCount={patientList?.metadata?.total ?? 0}
          getActivePage={onPageChange}
          reportView
        />
      )}
    </>
  );
}
